
import { useEffect } from 'react';
import Hero from './components/Hero';
import TrustBanner from './components/TrustBanner';
import Founders from './components/Founders';
import Services from './components/Services';
import Industries from './components/Industries';
import PipelineAmp from './components/PipelineAmp';
import AreasWeServe from './components/AreasWeServe';
import CTA from './components/CTA';
import About from './components/About';
import EmergencyCTA from './components/EmergencyCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import { useSEO, getOrganizationSchema, getWebPageSchema, combineSchemas } from '../../utils/seo';

export default function HomePage() {
  const organizationSchema = getOrganizationSchema();
  const webPageSchema = getWebPageSchema(
    'Million Dollar Contractors | Digital Marketing Agency for Home Service Contractors',
    'Million Dollar Contractors specializes in digital marketing for home service contractors. Expert web design, AI integration, SEO, social media ads, Google LSA + PPC, and reputation management.',
    '/'
  );

  useSEO({
    title: 'Million Dollar Contractors | Digital Marketing Agency for Home Service Contractors | Web Design, SEO & AI',
    description: 'Million Dollar Contractors specializes in digital marketing for home service contractors. Expert web design, AI integration, SEO, social media ads, Google LSA + PPC, and reputation management for electrical, HVAC, landscaping, pest control, plumbing, and roofing businesses.',
    keywords: 'contractor digital marketing, home service marketing, contractor web design, contractor SEO, HVAC marketing, plumbing marketing, roofing marketing',
    canonical: '/',
    schema: combineSchemas(organizationSchema, webPageSchema)
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <TrustBanner />
      <Founders />
      <Services />
      <Industries />
      <PipelineAmp />
      <AreasWeServe />
      <CTA />
      <About />
      <EmergencyCTA />
      <Contact />
      <Footer />
    </div>
  );
}
